














































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
// Import FilePond
import vueFilePond from 'vue-filepond';

// Import plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';

// Import styles
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css';
import { Observable } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';

// Create FilePond component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginFilePoster,
);
@Component({
  name: 'bpc-import-coda-modal',
  components: {
    FilePond,
  },
})
export default class ImportCodaModal extends Vue {
  @Prop(Boolean) readonly importInProgress: boolean;
  loading: boolean = false;
  importCodaFileObservableSubscription = null;
  entityName: string = 'coda';
  codaFile = null;

  get modalId() {
    return 'import-coda-modal';
  }

  get modalTitle() {
    return this.$t(`global.modals.import.coda`);
  }

  onOpenModal() {
    this.codaFile = null;
    this.$bvModal.show(this.modalId);
  }
  onCloseModal() {
    this.$bvModal.hide(this.modalId);
    this.$emit('click-on-close');
  }

  importCodaFile(): void {
    this.loading = true;
    const path = `${this.$bpcApiRouteHelper.getEntityPath(this.entityName)}/import`;
    const formData = new FormData();
    formData.append('coda_file', this.codaFile.file);
    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.postWithMedia(
      path,
      formData,
    );

    if (this.importCodaFileObservableSubscription) {
      this.importCodaFileObservableSubscription.unsubscribe();
    }
    this.importCodaFileObservableSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.$emit('sent-coda-import');
        this.loading = false;
      },
      error => {
        if (error.response.status === 422) {
          this.$bpcMessage.showErrorMessage({
            text: 'global.validation.coda.import.required.label',
          });
        }
        this.$emit('error-importing-coda');
        this.loading = false;
      },
    );
  }

  addFile(error, file) {
    this.codaFile = file;
  }
}
